<template>
  <v-app-bar app color="secondary" dark>
    <v-row no-gutters class="align-center">
      <v-col class="text-right">
        <v-toolbar-title class="v-header">{{ pageTitle }}</v-toolbar-title>
      </v-col>
      <v-col class="text-left">
        <v-btn text dark fab @click="logout()" :loading="logoutLoading" :ripple="false">
          <v-icon color="primary">mdi-logout</v-icon>
        </v-btn>
      </v-col>
    </v-row>
  </v-app-bar>
</template>
<script>
    import {mapActions, mapState} from "vuex";

    export default {
        name: 'appbar',
        data: function () {
            return {
                title: false,
                logoutLoading: false,
            }
        },
        computed: {
            ...mapState(['pageTitle', 'showSidebar', 'pageActions', 'userData']),
        },
        methods: {
            ...mapActions(['setSidebar']),
            ...mapActions('user', ['logoutUser']),
            async logout() {
                this.logoutLoading = true;
                await this.logoutUser();
                this.logoutLoading = false;
            }
        },
    }
</script>
<style scoped>
  .v-header {
    font-family: 'Cinema';
    font-size: 2rem;
    color: #fbb545;
  }

  .v-app-bar /deep/ .v-btn {
    margin: 0 -15px;
  }

  .v-app-bar /deep/ .v-btn:hover::before,
  .v-app-bar /deep/ .v-btn:before {
    opacity: 0;
    background-color: transparent;
  }
</style>